// extracted by mini-css-extract-plugin
export default {"sidebar":"Sidebar_sidebar__ZsqWF","sidebar__wrapper":"Sidebar_sidebar__wrapper__Q4TM3","sidebar__support":"Sidebar_sidebar__support__VwM7Y"};